<div class="dashboardWidgetContainer">
    <h2>{{ dashboardWidgetConfiguration?.title }}</h2>
    <div class="echartchPieContainer">
        @if (dashboardWidgetConfiguration?.total) {
            <div class="donut">
                <p class="total-text">
                    {{ 'dashboard.total' | translate }} <br /><span class="count">{{ dashboardWidgetConfiguration?.total }}</span>
                </p>
            </div>
        }
        <div
            class="chPieChart"
            echarts
            [options]="pieChartOptions"
            (chartClick)="onChartEvent($event)"
            (chartLegendSelectChanged)="onLegendEvent($event)"
        ></div>
    </div>
</div>
